<template>
  <div id="app" :class="[{'app-autoscrolling' : pageIsAutoScrolling}, 'app-' + browser]">
    <template v-if="!pageReady && !isErrorPage">
      <transition name="preloader-fade">
        <div class="preloader-container">
          <div class="preloader-inner">
            <div class="preloader" :class="{'animated': pageLoaded}">
              <svg width="103" height="49" viewBox="0 0 103 49">
                <g fill="none" fill-rule="evenodd">
                  <path fill="#FFF" d="M54.924 21.546h3.58l-7.85-8.12c3.29-.187 6.126-2.438 6.126-6.084 0-3.912-2.89-6.163-6.76-6.163H44.21v20.366h2.546v-8.683l8.166 8.683zM46.758 3.43h3.208c2.65 0 4.27 1.554 4.27 3.94 0 2.223-1.354 3.94-5.25 3.94-1.512 0-1.884 0-2.228-.028V3.43zm14.184 10.72c0 4.394 3.287 7.718 7.848 7.718 4.667 0 7.954-3.324 7.954-7.72V1.18H74.2V13.4c0 3.324-1.83 6.058-5.357 6.058-3.526 0-5.356-2.734-5.356-6.057V1.18h-2.545v12.97zm31.684-7.156c-.292-4.127-2.89-6.137-6.23-6.137-3.315 0-6.205 2.117-6.205 5.628 0 2.626 1.485 4.395 4.48 5.574l2.573 1.018c1.83.723 3.13 1.74 3.13 3.323 0 1.796-1.592 3.216-3.792 3.216-2.836 0-3.95-1.554-4.162-3.778h-2.546c.32 4.074 2.917 6.03 6.576 6.03 3.87 0 6.47-2.385 6.47-5.68 0-2.467-1.486-4.37-4.693-5.576l-2.546-.965c-1.99-.75-2.944-1.715-2.944-3.242 0-1.394.77-3.297 3.633-3.297 2.146 0 3.525 1.474 3.87 3.886h2.386z"/>
                  <path fill="#000" d="M1.075 21.546h10.42v-2.412H3.62V12.46h7.875v-2.41H3.62V3.59h7.875V1.18H1.075v20.366zm13.893 0h9.625v-2.412h-7.08V1.18H14.97v20.366zm12.41 0h7.29c3.393 0 6.07-2.438 6.07-5.762 0-2.466-1.43-4.53-3.923-4.904v-.053c1.512-.75 2.52-2.118 2.52-4.02 0-2.064-.93-3.538-2.175-4.45-1.193-.857-2.545-1.178-4.534-1.178h-5.25v20.366zm2.544-2.25V12.3h3.87c3.42 0 4.402 1.903 4.402 3.51 0 1.85-.98 3.485-4.4 3.485H29.92zm0-9.247V3.43H32.6c1.485 0 2.518.32 3.18.938.638.59 1.01 1.447 1.01 2.492 0 1.983-1.618 3.19-3.687 3.19h-3.18zM17.72 30.443c-1.618-1.5-4.242-2.6-6.92-2.6C3.96 27.845.117 33.312.117 38.35c0 5.038 3.844 10.504 10.683 10.504 2.545 0 5.196-1.072 6.998-2.733l-1.617-1.85c-1.404 1.34-3.153 2.17-5.38 2.17-4.11 0-7.98-3.35-7.98-8.092 0-4.69 3.765-8.092 7.98-8.092 1.935 0 3.765.777 5.196 2.09l1.723-1.902zM34.896 48.53h2.783l-8.19-20.364H27.26l-8.19 20.365h2.782l1.83-4.742h9.384l1.83 4.743zm-2.704-6.993h-7.635l3.818-9.995 3.817 9.995zm8.138 6.994h2.546v-6.94h3.022c4.268 0 6.812-3.295 6.812-6.698 0-3.403-2.544-6.726-6.812-6.726H40.33V48.53zm2.546-9.19v-8.923h2.492c3.048 0 4.798 1.528 4.798 4.475 0 2.947-1.75 4.448-4.798 4.448h-2.492zm12.697 9.19h2.545V28.167h-2.545V48.53zm10.18 0h2.544V30.58h5.037v-2.412H60.716v2.412h5.037V48.53zm22.166 0H90.7l-8.19-20.364h-2.227L72.093 48.53h2.784l1.83-4.742h9.383l1.83 4.743zm-2.705-6.993H77.58l3.818-9.995 3.817 9.995zm8.138 6.994h9.623v-2.41h-7.078V28.165h-2.545V48.53z"/>
                </g>
              </svg>
            </div>
          </div>
        </div>
      </transition>
    </template>
    <HeaderComponent v-if="!isErrorPage"></HeaderComponent>
    <router-view></router-view>
  </div>
</template>

<script>
  import HeaderComponent from '@/components/HeaderComponent';
  import { mapGetters } from 'vuex';
  import checkAllImages from '@/helpers/checkAllImages';
  import browserDetect from '@/helpers/browserDetect';

  export default {
    name: 'app',
    computed: mapGetters({
      page: 'page',
      pageReady: 'pageReady',
      pageLoaded: 'pageLoaded',
      isErrorPage: 'isErrorPage',
      currentPage: 'currentPage',
      pageIsAutoScrolling: 'pageIsAutoScrolling',
    }),
    data() {
      return {
        sections: [],
        browser: browserDetect(),
      };
    },
    components: {
      HeaderComponent,
    },
    mounted() {
      window.addEventListener('scroll', this.detectCurrentPage);
      checkAllImages();
    },
    watch: {
      pageIsAutoScrolling() {
        this.detectCurrentPage();
      },
    },
    methods: {
      detectPageContainers() {
        if (this.sections.length < 5) {
          this.sections = document.querySelectorAll('.section');
        }
      },
      detectCurrentPage() {
        if (this.pageIsAutoScrolling) return;
        const currentTop = window.pageYOffset;
        const currentMiddle = currentTop + (window.innerHeight / 2);

        let parentId = '';
        let isActive;

        this.detectPageContainers();

        for (let i = 0; i < this.sections.length; i += 1) {
          const elemTop = this.sections[i].offsetTop;

          if (currentMiddle >= elemTop) {
            isActive = this.sections[i];
          }
        }

        if (!isActive) {
          parentId = 'home';
        } else {
          parentId = isActive.parentElement.id;
        }
        if (parentId !== this.currentPage) {
          this.$store.commit('SET_CURRENT_PAGE', parentId);
        }
      },
    },
  };
</script>

<style>
  @font-face {
    font-family: 'DietDidotTitleBold';
    src: url('assets/fonts/DietDidotTitleBold.eot');
    src: local('☺'), 
       url('/f/dist/static/fonts/DietDidotTitleBold.woff') format('woff'),
       url('/f/dist/static/fonts/DietDidotTitleBold.ttf') format('truetype'),
       url('/f/dist/static/fonts/DietDidotTitleBold.svg') format('svg');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'icomoon';
    src:  url('/f/dist/static/fonts/icomoon.eot?2l9wif');
    src:  url('/f/dist/static/fonts/icomoon.eot?2l9wif#iefix') format('embedded-opentype'),
      url('/f/dist/static/fonts/icomoon.ttf?2l9wif') format('truetype'),
      url('/f/dist/static/fonts/icomoon.woff?2l9wif') format('woff'),
      url('/f/dist/static/fonts/icomoon.svg?2l9wif#icomoon') format('svg');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'UniversLTStdLight';
    src: url('/f/dist/static/fonts/Aileron.eot');
    src: url('/f/dist/static/fonts/Aileron.eot?#iefix') format('embedded-opentype'),
         url('/f/dist/static/fonts/Aileron.woff2') format('woff2'),
         url('/f/dist/static/fonts/Aileron.woff') format('woff'),
         url('/f/dist/static/fonts/Aileron.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'UniversLTStdBold';
    src: url('/f/dist/static/fonts/AileronBold.eot');
    src: url('/f/dist/static/fonts/AileronBold.eot?#iefix') format('embedded-opentype'),
         url('/f/dist/static/fonts/AileronBold.woff2') format('woff2'),
         url('/f/dist/static/fonts/AileronBold.woff') format('woff'),
         url('/f/dist/static/fonts/AileronBold.ttf') format('truetype');
    font-weight: bold;
    font-style: normal;
  }

  [class^="icon-"], [class*=" icon-"] {
    /* use !important to prevent issues with browser extensions that change fonts */
    font-family: 'icomoon' !important;
    speak: none;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;

    /* Better Font Rendering =========== */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .icon-arrow-left:before {
    content: "\e900";
    font-size: 36px;
  }
  .icon-arrow-right:before {
    content: "\e901";
    font-size: 36px;
  }
  .icon-exit:before {
    content: "\e902";
  }

  @keyframes preloaderTextAnimation {
    0%   {
      opacity: 0;
    }
    50% { 
      opacity: 1;
    }
    100% { 
      opacity: 0;
    }
  }

  html {
    margin: 0;
    padding: 0;
    -webkit-text-size-adjust: 100%;
  }

  body {
    margin: 0;
    padding: 0;
    background: #570803;
    font-size: 18px;
    line-height: 175%;
    font-family: 'UniversLTStdLight', Helvetica, Arial, sans-serif;
  }

  * {
    box-sizing: border-box;
  }

  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #fff;
  }

  h1, h2, h3, h4 {
    margin: 0;
    padding: 0;
    line-height: 110%;
    font-weight: normal;
  }

  h1 {
    font-size: 160px;
    font-family: 'DietDidotTitleBold';
  }

  h2 {
    font-size: 50px;
    line-height: 56px;
    margin-top: 50px;
  }

  h3 {
    font-size: 18px;
    line-height: 30px;
    margin: 60px 0 20px;
    font-family: 'UniversLTStdBold';
  }

  h4 {
    font-size: 18px;
    color: rgba(0, 0, 0, 0.6);
    margin: 0 0 10px;
  }

  h2 + h3 {
    margin-top: 40px;
  }

  h3 + h2 {
    margin-top: 20px;
  }

  h1:first-child,
  h2:first-child,
  h3:first-child,
  h4:first-child {
    margin-top: 0;
  }

  ul, ol {
    margin: 0 0 25px;
    padding: 0;
    list-style-type: none;

    li {
      margin: 0 0 10px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  ul {
    li {
      position: relative;

      &:before {
        content: '';
        width: 7px;
        height: 7px;
        background: $main-color;
        display: inline-block;
        vertical-align: middle;
        margin: -1px 13px 0 -20px;
      }
    }
  }

  ol {
      counter-reset: item;
      list-style-type: none;
      position: relative;

    & > li:before { 
      content: counter(item) "."; 
      counter-increment: item;
      color: $main-color;
      position: absolute;
      left: -25px;
    }
  }

  p {
    padding: 0;
    margin: 0 0 20px;
  }

  a {
    outline: none;
    text-decoration: none;
    color: #fff;
    border-bottom: 1px solid $main-color;
    transition: all 0.3s ease;

    &:hover {
      color: $main-color;
    }

    &.no-underline {
      border: none;
    }

    .light-bg & {
      color: $darkest-color;
      border-color: $main-color;

      &:hover {
        color: $main-color;
        border-color: $main-color;
      }
    }

    .phone & {
      cursor: default;
      border: none;

      &:hover {
        color: $lightest-color;

        .light-bg & {
          color: $darkest-color;
        }
      }
    }
  }

  blockquote {
    font-size: 50px;
    line-height: 56px;
    margin-top: 50px;
    color: #d4e3ec;
    margin: 60px 0;
    text-indent: -24px;
  }

  .nowrap,
  .phone {
    white-space: nowrap;
  }

  .reduced-width {
    max-width: 1400px;
    margin: 0 auto;
    position: relative;
  }

  .cols {
    & > .col {
      display: inline-block;
      vertical-align: top;
      margin-right: 10%;

      &_main {
        width: 50%;
      }

      &_extra {
        width: 39%;
      }

      &:last-child {
        margin-right: 0;
      }
    }

    &_2 {
      .col {
        width: 43%;

        &:last-child {
          margin-right: 0;
        }
      }
    }

    &_3 {
      .col {
        width: 23.5%;

        &:last-child {
          margin-right: 0;
        }
      }
    }

    & + .cols {
      margin-top: 60px;
    }
  }

  .comment {
    color: rgba(0, 0, 0, 0.6);
  }

  .content {
    background: #fff;
    padding: 90px 100px;
    color: #000;

    &_team {
      padding: 65px 75px;
    }
  }

  .section {
    position: relative;

    &-container {
      position: relative;
    }

    &__top {
      height: 100vh;
      min-height: 700px;
      position: relative;
      z-index: 0 !important;

      opacity: 0;
      transform: scale(0.9);
      transition: all 0.5s ease;

      .active & {
        opacity: 1;
        transform: scale(1);
      }
    }

    &__text {
      padding: 50px 25px;
      padding-top: calc(20vh + 50px);

      .app-ie & {
        transition: opacity 0.3s ease;
      }

      .app-autoscrolling.app-ie & {
        opacity: 0;
      }
    }

    &__main {
      position: relative;
      padding: 100px 25px 0;
    }
  }

  .popup {
    position: relative;

    &__content {
      position: relative;
      height: 100%;
    }

    &__close {
      cursor: pointer;
      position: absolute;
      top: 25px;
      right: 25px;
      font-size: 30px;
      transition: color 0.2s ease;

      &:hover {
        color: $main-color;
      }
    }
  }

  .fader {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 5;
  }

  .preloader-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: $darkest-color;
    z-index: 100;
  }

  .preloader-inner {
    max-width: 1400px;
    margin: 0 auto;
    height: 100%;
    position: relative;
  }

  .preloader {
    position: absolute;
    height: 115px;
    width: 95px;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    transition: all 1.2s cubic-bezier(0.510, 0.380, 0.195, 0.900);
    transform-origin: center center;

    &:before {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      border-left: 95px solid $main-color;
      border-top: 115px solid transparent;
    }

    &.animated {
      left: 25px;
      top: 20px;
      transform: translate3d(0, 0, 0);

      svg {
        animation: none;
      }
    }

    svg {
      position: absolute;
      left: 5px;
      bottom: 4px;
      width: 50px;
      height: 24px;
      animation: preloaderTextAnimation 2s ease infinite;
    }
  }

  .preloader-fade {
    &-enter,
    &-leave {
      &-active {
        transition: 0.8s cubic-bezier(0.455, 0.065, 0.000, 0.990);
      }
    }

    &-enter,
    &-leave-to {
      opacity: 0;
    }
  }

  .error {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: $darkest-color;
    text-align: center;

    &:before {
      content: '';
      height: 100%;
      display: inline-block;
      vertical-align: middle;
    }

    &__inner {
      max-width: 425px;
      padding: 25px;
      position: relative;
      display: inline-block;
      vertical-align: middle;

      &:before {
        content: '';
        width: 272px;
        height: 328px;
        background: url('/f/dist/static/img/404.gif') 0 0 no-repeat;
        position: absolute;
        top: -200px;
        left: 58%;
        z-index: -1;
        transform: translateX(-50%);
      }
    }

    &__title {
      font-size: 177px;
      line-height: 80%;
      font-family: 'DietDidotTitleBold', Georgia;
    }

    &__text {
      font-size: 46px;
      line-height: 100%;
      font-family: 'DietDidotTitleBold', Georgia;
      margin-bottom: 20px;
    }

    p {
      text-align: left;
    }
  }

  @media (max-width: 1185px) {
     .page_ru h1 {
       font-size: 140px;
       line-height: 142px;
     }
  }

  @media (max-width: 1150px) {
     .page_ru h1 {
       font-size: 115px;
      line-height: 123px;
     }
  }

  @media (max-width: 990px) {
    h1 {
      font-size: 130px;
      line-height: 130px;
    }
  }

  @media (max-width: 850px) {
    h1 {
      font-size: 57px;
      line-height: 120%;

      .page_ru & {
        font-size: 50px;
        line-height: 100%;
      }
    }

    h2 {
      font-size: 30px;
      line-height: 120%;
    }

    ul {
      margin-left: 21px;
    }

    ol {
      margin-left: 25px;
    }

    blockquote {
      font-size: 40px;
      line-height: 46px;
    }

    .cols {
      margin-bottom: 55px;

      & > .col {
        display: block;
        padding: 0;
        /*margin-top: 55px;*/

        &_main,
        &_extra {
          width: 100%;
        }

        &_extra {
          margin-top: 55px;
        }
      }

      &_2,
      &_3 {
        .col {
          width: 100%;
        }
      }
    }

    .section {
      &__top {
        padding-top: 75px;
      }

      &__main {
        padding: 0 25px;

        #news & {
          padding-top: 95px;
        }
      }

      &__text {
        padding: 25px;
      }
    }

    .content {
      margin: 0 -25px;
      padding: 50px 25px;

      &_team {
        margin: 0 -25px;
      }
    }

    .fader {
      display: none;
    }

    .preloader {
      position: absolute;
      height: 61px;
      width: 50px;

      &:before {
        border-left: 50px solid $main-color;
        border-top: 61px solid transparent;
      }

      svg {
        left: 2px;
        bottom: 2px;
        width: 27px;
        height: 14px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue?5749db3a